import { lazy } from 'react';

// React.lazy for route-level code splitting, with one safety net: after a
// deploy, a browser that still has the previous index.html open asks for code
// chunks that no longer exist. In that case reload the page once (to pick up
// the new build) instead of showing an error; a second failure is surfaced
// normally so a real outage can never cause a reload loop.
const RELOAD_KEY = 'ebuddhi_chunk_reload';

const isChunkError = (err) =>
  !!err && (err.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/i.test(String(err.message || '')));

const lazyWithRetry = (factory) =>
  lazy(() =>
    factory()
      .then((module) => {
        try { sessionStorage.removeItem(RELOAD_KEY); } catch (e) { /* storage unavailable */ }
        return module;
      })
      .catch((err) => {
        let alreadyReloaded = false;
        try { alreadyReloaded = sessionStorage.getItem(RELOAD_KEY) === '1'; } catch (e) { /* storage unavailable */ }
        if (isChunkError(err) && !alreadyReloaded) {
          try { sessionStorage.setItem(RELOAD_KEY, '1'); } catch (e) { /* storage unavailable */ }
          window.location.reload();
          return new Promise(() => {}); // keep showing the loader while the page reloads
        }
        throw err;
      })
  );

export default lazyWithRetry;
